<template>
  <div class="contact-us-container">
    <h2>Request a call</h2>

    <div class="cabinet-labelled-input">
      <div class="col">
        <div class="placeholder">YOUR FIRST NAME*</div>
        <input type="text" v-model="firstName">
      </div>
      <div class="check-indicator" :class="{'check-indicator-valid': firstNameValid}"></div>
    </div>

    <div class="cabinet-labelled-input">
      <div class="col">
        <div class="placeholder">YOUR LAST NAME*</div>
        <input type="text" v-model="lastName">
      </div>
      <div class="check-indicator" :class="{'check-indicator-valid': lastNameValid}"></div>
    </div>

    <div class="cabinet-labelled-input">
      <div class="col">
        <div class="placeholder">YOUR TELEPHONE NUMBER*</div>
        <div class="language-selection">
          <div class="flag" :class="{'flag-co': phoneFlagCO, 'flag-mx': phoneFlagMX}"></div>
          <input type="text" v-model="phoneNumber">
        </div>
      </div>
      <div class="check-indicator" :class="{'check-indicator-valid': phoneValid}"></div>
    </div>

    <div class="cabinet-labelled-input">
      <div class="col">
        <div class="placeholder">YOUR EMAIL*</div>
        <input type="email" v-model="email">
      </div>
      <div class="check-indicator" :class="{'check-indicator-valid': emailValid}"></div>
    </div>

    <CustomSelector :class="{'no-row-r-icon': supportLanguage == null}" v-model="supportLanguage" title="SUPPORT LANGUAGE*" :options="languages"></CustomSelector>
    <CustomSelector :class="{'no-row-r-icon': country == null}" v-model="country" title="COUNTRY*" :options="countries"></CustomSelector>

    <div class="cabinet-labelled-input">
      <div class="col">
        <div class="placeholder">PREFERRED TIME TO CALL</div>
        <input type="text" v-model="preferredTime">
      </div>
      <!--      <div class="check-indicator" :class="{'check-indicator-valid': preferedTimeValid}"></div>-->
    </div>

    <label class="input-checkbox">Call me as soon as possible
      <input type="checkbox" v-model="callMeASAP">
      <span class="checkmark"></span>
    </label>

    <button class="red-button" @click="change">Change</button>
  </div>
</template>

<script>
import {API} from "@aws-amplify/api";
import {graphqlOperation} from "@aws-amplify/api-graphql";
import {createContactRequest} from "@/graphql/mutations";

import CustomSelector from "@/components/CustomSelector";

export default {
  name: "ContactUs",
  components: {CustomSelector},
  data() {
    return {
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      supportLanguage: null,
      country: null,
      preferredTime: null,

      supportFlagGB: false,
      supportFlagES: false,

      phoneFlagCO: false,
      phoneFlagMX: false,

      countryFlagCO: false,
      countryFlagMX: false,

      firstNameValid: false,
      lastNameValid: false,
      emailValid: false,
      phoneValid: false,
      supportLanguageValid: false,
      countryValid: false,
      preferedTimeValid: false,

      callMeASAP: false,

      languages: [
        {
          icon: '/assets/images/flags/gb.svg',
          text: 'English',
          value: 'ENGLISH'
        },
        {
          icon: '/assets/images/flags/es.svg',
          text: 'Español',
          value: 'SPANISH'
        },

      ],
      countries: [
        {
          icon: '/assets/images/flags/co.svg',
          text: 'Colombia',
          value: 'co'
        },
        {
          icon: '/assets/images/flags/mx.svg',
          text: 'México',
          value: 'mx'
        },
      ]
    };
  },
  created() {
    window.addEventListener('keydown', this.reset);

    let userInfo = this.$store.state.user;
    if (userInfo != null) {
      this.firstName = userInfo.firstName;
      this.lastName = userInfo.lastName;
      if (userInfo.phones != null && userInfo.phones.length > 0)
        this.phoneNumber = userInfo.phones[0];
      else
        this.phoneNumber = null;
      this.email = userInfo.email;
      this.country = userInfo.country;
      if (userInfo.preference != null) {
        this.supportLanguage = userInfo.preference.emailsLanguage;

      } else {
        this.supportLanguage = "ENGLISH";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.reset);
  },
  watch: {
    firstName() {
      this.firstNameValid = (this.firstName != null && this.firstName.length > 0);
    },
    lastName() {
      this.lastNameValid = (this.lastName != null && this.lastName.length > 0);
    },
    phoneNumber() {
      this.phoneValid = (this.phoneNumber != null && this.phoneNumber.length > 0);
      if (this.phoneNumber != null) {
        this.phoneFlagCO = this.phoneNumber.includes('+57');
        this.phoneFlagMX = this.phoneNumber.includes('+52');
      } else {
        this.phoneFlagCO = false;
        this.phoneFlagMX = false;
      }
    },
    email() {
      this.emailValid = (this.email != null && this.email.length > 0 && this.email.includes('@'));
    },
    supportLanguage() {
      this.supportFlagGB = (this.supportLanguage === 'ENGLISH');
      this.supportFlagES = (this.supportLanguage === 'SPANISH');
      this.supportLanguageValid = (this.supportFlagGB || this.supportFlagES);
    },
    country() {
      this.countryFlagCO = (this.country === 'co');
      this.countryFlagMX = (this.country === 'mx');
      this.countryValid = (this.countryFlagCO || this.countryFlagMX);
    }
  },
  methods: {
    validate() {
      return this.firstNameValid && this.lastNameValid;
    },
    change() {
      console.log('change!');
      let that = this;
      //  TODO: should be tied to the enabled button attribute
      if (this.validate()) {
        let userInfo = this.$store.state.user;
        let userID = null;
        if (userInfo != null)
          userID = userInfo.id;

        API.graphql(graphqlOperation(createContactRequest, {
          input: {
            userID: userID,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phoneNumber,
            email: this.email,
            supportLanguage: this.supportLanguage,
            country: this.country,
            preferences: this.preferredTime,
            callMeASAP: this.callMeASAP
          }
        })).then((result) => {
          console.log('--- CREATE CONTACT REQUEST ---');
          console.log(result);
          that.reset({key: 'Escape'});
        }).catch((error) => {
          console.log(error);
        });
      } else {
        console.log('INVALID');
      }
    },
    reset(e) {
      if (e.key === 'Escape') {
        this.firstName = null;
        this.lastName = null;
        this.phoneNumber = null;
        this.email = null;
        this.supportLanguage = null;
        this.country = null;
        this.preferredTime = null;

        this.supportFlagGB = false;
        this.supportFlagES = false;

        this.phoneFlagCO = false;
        this.phoneFlagMX = false;

        this.countryFlagCO = false;
        this.countryFlagMX = false;

        this.firstNameValid = false;
        this.lastNameValid = false;
        this.phoneValid = false;
        this.emailValid = false;
        this.supportLanguageValid = false;
        this.countryValid = false;
        this.preferedTimeValid = false;

        this.callMeASAP = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
